import type {
  ViewAutoConfiguratorDataInput,
  ViewAutoConfiguratorDataResponse,
} from '@snap-types/actions/view-auto-configurator-data';
import { AUTO_CONFIGURATOR_SLICE_NAME } from '@ui/constants/auto-configurator';
import { buildSiteUrl } from '@ui/store/api-builder/build-url';
import { injectQuery } from '@ui/store/api-builder/inject-query';

const [_, useViewAutoConfiguratorDataQuery] = injectQuery<
  ViewAutoConfiguratorDataInput,
  ViewAutoConfiguratorDataResponse
>(
  `${AUTO_CONFIGURATOR_SLICE_NAME}/viewAutoConfiguratorData`,
  ({ siteCode }) => ({
    url: buildSiteUrl(siteCode, 'auto-configurator/import/latest'),
  }),
);

export { useViewAutoConfiguratorDataQuery };
